module.exports = __webpack_public_path__ + "static/media/WhitneySSm-Medium-Adv_Web.c4a58337.woff";